import React from 'react';

import { EventInfoCell } from '@vlabs/shared/components/event-info-cell/EventInfoCell';
import { Tag, useWindowSize } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import st from './EventDataCell.module.sass';

export const EventDataCell = ({ original }) => {
  const { t } = useTranslation();
  const windowSize = useWindowSize();

  return (
    <div className={st.Root}>
      <Tag
        kind="neutral"
        size={windowSize.width < 1920 ? 'medium' : 'large'}
        value={original?.top_match ? t('match') : t('detection')}
      />
      <EventInfoCell className={st.EventInfoCell} isColumnDirection={false} original={original} />
    </div>
  );
};
